import {Component, OnInit} from '@angular/core';
import {SelectItem} from "primeng/api";
import {Job} from "../domain/job";
import {StorageService} from "../services/storage.service";
import {ResourcesService} from "../services/resource.service";
import * as _ from 'underscore';
import {SharedDataService} from "../services/shared-data.service";
import {JobsService} from "../services/jobs.service";
import {AuthenticationGuard} from '../oauth/authentication.guard';

@Component({
    selector: 'app-new-job-details',
    templateUrl: './new-job-details.component.html',
    styleUrls: ['./new-job-details.component.css'],
    standalone: false
})
export class NewJobDetailsComponent implements OnInit {

  resource: string;
  resources: SelectItem[];

  jobExists=true;
  selectedJob: Job;

  // Messages for user
  messageOne: string;
  messageTwo: string;
  messageThree: string;

  // input and dropdown  booleans
  jobSelected: boolean;
  jobNameSelected: boolean;
  resourceSelected: boolean;

  // For getResources function
  idToken;
  i: number;
  data: string[];


  // Input data to find Job
  selectedJobName: string;
  selectedJobId: number;
  selectedUser: string;
  selectedResource: string;


  constructor(private jobsService: JobsService,private storageService: StorageService,
              private resourcesService: ResourcesService,
              private sharedDataService: SharedDataService, private authorizationService: AuthenticationGuard) {
  }

  ngOnInit() {
    this.authorizationService.checkLogin();
    this.messageOne = "No resource selected"
    this.messageTwo = "No Job selected"
    this.messageThree = "Job does not exist"
    this.jobNameSelected= false;
    this.jobSelected=false;
    this.getResources();
  }


  filterResources(selected: string) {
    this.reset();
    this.resourceSelected=true;
  }


  getResources(): void {
    this.resources = [];
    this.idToken = this.storageService.getItem('encodedAccessToken');
    setTimeout(() => {

      this.resourcesService.getResources(this.idToken)
        .subscribe(resources => {
            this.data = resources;
          },
          error => {

            console.error('Error retrieving resource systems' + error);
            this.resources.push({label: 'AS400-AAA', value: 'AS400-AAA'});
            // In case authError the AAA data is retrieved
          }, () => {

            for (let i = 0; i < this.data.length; i++) {

              this.resources.push({label: this.data[i], value: this.data[i]});

            }
            this.resources = _.sortBy(this.resources, 'label');
            // If resource is informed in sharedDataService, meaning the user clicked on Go Back on details section,
            // then, that resource is loaded. If not, default value is loaded
            if (this.sharedDataService.resource) {
              this.resource = this.sharedDataService.resource;

            } else {
              this.resource = this.resources[0].value;
            }

          });

    });

  }



  getJob() {
     if(this.selectedJobId&& this.selectedJobName && this.selectedUser){
       this.jobSelected=true;
     }
  }


  reset(){
    this.selectedJobName = null;
    this.selectedJobId= null;
    this.selectedUser= null;
    this.jobSelected=false;
  }

}






